import api from "@/services/api.service";

export default {
 name: 'show-conflict',
 components: {},
 props: {
  caption: {
    type: String,
    default: "Imported Contact list"
  },
  hover: {
    type: Boolean,
    default: true
  },
  striped: {
    type: Boolean,
    default: true
  },
  bordered: {
    type: Boolean,
    default: false
  },
  small: {
    type: Boolean,
    default: false
  },
  fixed: {
    type: Boolean,
    default: false
  }
},
data() {
  return {
    contact_data: [],
    fields: [],
    conflict_data:[],  
    levelDiscription : {'ExachMacth':'','UpdateMatch': '','ConflictMatch': ''},       
    status:'',
    formField:[],     
    errorClass: 'bg-warning',
    permission_viewConflict: false,
    permission_importedList: false,
    permission_deleteImportedContact: false,
    superAdmin: false,
    md:"6",
    md1:"12",
    editField : ''
  };
},
watch: {},
async created() {
  let response = await api.post("users/user-permissions");
        const permissions = [];
        if (response.status == "success") {
          response.data[0].permission.forEach( function(element) {                
              permissions.push(element.action)
          }.bind(this));
        if(permissions.includes("view_conflict_imported_contact") == true){
          this.getImportedContact();
          this.permission_importedList = permissions.includes("list_imported_contact");
          this.permission_viewConflict = permissions.includes("view_conflict_imported_contact");
          this.permission_deleteImportedContact = permissions.includes("delete_imported_contact");
        }else if(response.data[0].role == 'super_admin'){
          this.getImportedContact();
          this.superAdmin = true;
        }else if(permissions.includes("list_imported_contact") == true){
            this.makeToast("Permission denied","Alert","warning",6000);
            this.$router.push({name: 'Imported Contact List'});
        }else if(permissions.includes("list_import_contact") == true || permissions.includes("add_import_contact") == true){
            this.makeToast("Permission denied","Alert","warning",6000);
            this.$router.push({name: 'Import Contact List'});
        }else{
            this.makeToast("Permission denied","Alert","warning",6000);
            this.$router.push({name: 'Admin Dashboard'});
        }
      }
},
methods: {
  focusField(name){
    console.log(name);
    this.editField = name;
  },
  async blurField(field,data){
    let response = await api.post('admin/import-contact/edit-imported-contact', {id : this.$route.params.conflict_id, fieldKey: field, fieldData: data});
    if (!response)
      this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)

    if (response.status == 'success') {
      this.makeToast('Saved!', 'Success', 'success', 6000);
    } else {
        this.makeToast(response.message, 'Alert', 'danger');
    }
  },
  // showField(name){
  //   return (this.user[name] == '' || this.editField == name)
  // },
  makeToast(message = "", title = "Alert", variant = "warning") {
    this.toastCount++;
    this.$root.$bvToast.toast(message, {
      title: title,
      variant: variant,
      autoHideDelay: 3000
    });
  },
  async getImportedContact() {
    let response = await api.post("admin/import-contact/imported-contact-list", {id : this.$route.params.conflict_id});          
    if (!response)
      this.makeToast("Something went to wrong please try again","Alert","danger",6000);
    if (response.status == "success") {
      if (response.data.data != "") {  
        //GET ALL HEADERS FROM JSON        
        var columns = Object.keys(Object.assign({}, ...[JSON.parse(response.data.contact_data)]));        
        columns.map((h) => {
         this.fields.push({key: h})
       });
        this.fields.push({key:'total_score'},{key:'total_waightage'},{key:'total_score_per'},{key:'updates_on'});
        this.status = response.data.status;  
        //Iterate Data
        this.contact_data = JSON.parse(response.data.contact_data);//Object.assign({}, JSON.parse(response.data.contact_data), {id:response.data.id});
        this.formField = JSON.parse(response.data.contact_data);;//Object.assign({}, JSON.parse(response.data.contact_data), {id:response.data.id});
        this.conflict_data = JSON.parse(response.data.conflict_data);
        var cnt = 0;
          for (const k in this.conflict_data) {
              if(this.conflict_data[k].length > 0){
                cnt = cnt + 1;
              }
          } 
          if(cnt == 1){ this.md = '12'; this.md1 = '6';  }
      } else {
        this.items = [];
      }
    }      
    this.isBusy = false;
  },  
  async edit(){
    if(!this.formField.id){        
      this.makeToast('Please select any updateds on column','Validation','danger');
      return;
    }
    this.formField.imported_conflict_id = this.$route.params.conflict_id;
    let response = await api.post('contact/edit-conflict-contact', this.formField);
    if (!response)
      this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)

    if (response.status == 'success') {
      this.makeToast(response.message, 'Success', 'success', 6000);
      // console.log(this.$route.params.id);
      this.$router.push({name: "Imported Contact List",params:{ 'id':this.$route.params.id} });      
    } else {
      for (var error in response.errors) {
        this.makeToast(response.errors[error], 'Alert', 'danger');
      }
    }
  },
  async editNext(){
    if(!this.formField.id){        
      this.makeToast('Please select any updateds on column','Validation','danger');
      return;
    }
    this.formField.imported_conflict_id = this.$route.params.conflict_id;
    let response = await api.post('contact/edit-conflict-contact', this.formField);
    if (!response)
      this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)

    if (response.status == 'success') {

        let responseNext = await api.post("admin/import-contact/ediNext",{import_contact_id: this.$route.params.id,response_id:this.$route.params.conflict_id});
        if(responseNext.status=='success'){
          this.makeToast(response.message, 'Success', 'success', 6000);
          return this.$router.push({name : "Imported Contact Conflict",params: {conflict_id:responseNext.data.id}});
        } else {
          this.makeToast(response.message, 'Success', 'success', 6000);
          this.makeToast("No response pending to resolve","Alert","warning",6000);
          this.$router.push({name: 'Import Contact List'});
        }
    } 
    else {
      for (var error in response.errors) {
        this.makeToast(response.errors[error], 'Alert', 'danger');
      }
    }
  },
  async keepBoth(){
    this.formField.imported_conflict_id = this.$route.params.conflict_id;
    let response = await api.post('contact/add-conflict-contact', this.formField);
    if (!response)
      this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)

    if(response.status=='success'){
      this.makeToast(response.message,'Success','success');
      this.$router.push({ name: "Imported Contact List" , params:{'id': this.$route.params.id}});
    }else{
      for(var error in response.errors){
        this.makeToast(response.errors[error],'Alert','danger');
      }
    }
  },
  async keepBothNext(){
    this.formField.imported_conflict_id = this.$route.params.conflict_id;
    let response = await api.post('contact/add-conflict-contact', this.formField);
    if (!response)
      this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)

    if(response.status=='success'){
      let responseNext = await api.post("admin/import-contact/ediNext",{import_contact_id: this.$route.params.id,response_id:this.$route.params.conflict_id});
        if(responseNext.status=='success'){
          this.makeToast(response.message, 'Success', 'success', 6000);
          return this.$router.push({name : "Imported Contact Conflict",params: {conflict_id:responseNext.data.id}});
        } else {
          this.makeToast(response.message, 'Success', 'success', 6000);
          this.makeToast("No response pending to resolve","Alert","warning",6000);
          this.$router.push({name: 'Import Contact List'});
        }
    }else{
      for(var error in response.errors){
        this.makeToast(response.errors[error],'Alert','danger');
      }
    }
  }
}
};
